<template>
  <div>
    <h1>Manage Okta User</h1>
    <div class="mt-5">
      <v-form ref="form">
        <v-text-field
          v-model="searchLogin"
          name="login"
          label="Login (usually the Email Address)"
          @keydown.native.enter.prevent="search"
          @keydown.native="reset"
        />
        <div v-if="oktaUserC == false">
          <h2>Create Okta User</h2>
          <v-text-field
            v-model="firstName"
            :rules="required"
            class="required"
            name="firstName"
            label="First Name"
          />
          <v-text-field
            v-model="lastName"
            :rules="required"
            class="required"
            name="lastName"
            label="Last Name"
          />
          <okta-group-select @change="groupId = $event.id" />
          <v-btn color="primary" @click.native="createTheUser">Create User</v-btn>
        </div>
        <v-btn v-show="oktaUser == null" color="primary" @click.native="search">Search</v-btn>
        <v-btn color="primary" @click.native="clear">Reset</v-btn>
      </v-form>
      <manage-okta-users-table v-if="oktaUserC" :okta-user="oktaUserC" />
    </div>
  </div>
</template>

<script>
import ManageOktaUsersTable from '@/components/manageOktaUsers/ManageOktaUsersTable'
import OktaGroupSelect from '@/components/manageOktaUsers/OktaGroupSelect'
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: 'manage-okta-users',
  components: {
    ManageOktaUsersTable,
    OktaGroupSelect
  },
  props: {
    login: String
  },
  data: () => ({
    searchLogin: '',
    firstName: '',
    lastName: '',
    groupId: '',
    required: [
      v => !!v || 'Required'
    ]
  }),
  computed: {
    ...mapState('oktaUsers', ['oktaUser']),
    ...mapGetters('oktaGroups', ['groupListValues']),
    oktaUserC: function() {
      if (!this.oktaUser) return this.oktaUser
      const user = this.oktaUser
      user.groups = this.groupListValues(this.oktaUser.groupIds)
      return user
    }
  },
  created() {
    this.getOktaUser(this.login)
    this.$router.push('/okta-users') //just to clear the parameter from the url
    if (this.login) this.searchLogin = this.login
  },
  methods: {
    ...mapActions('oktaUsers', ['getOktaUser', 'createUser', 'setOktaUser']),
    search: function() {
      this.getOktaUser(this.searchLogin)
    },
    createTheUser: function() {
      if (this.$refs.form.validate()) {
        this.createUser({ email: this.searchLogin, firstName: this.firstName, lastName: this.lastName, groupId: this.groupId })
      }
    },
    reset() {
      if (this.oktaUser != null) this.setOktaUser(null)
    },
    clear() {
      this.searchLogin = ''
      this.reset()
    }
  }
}
</script>
